export default __webpack_public_path__ + "static/media/IF_MyCapabilities_Big.d68701ee.jpg";